import { render, staticRenderFns } from "./reportSegment.vue?vue&type=template&id=795fb71a&scoped=true"
import script from "./reportSegment.vue?vue&type=script&lang=js"
export * from "./reportSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795fb71a",
  null
  
)

export default component.exports